import Settings from "@pixelpay/sdk-core/lib/models/Settings";
import Card from "@pixelpay/sdk-core/lib/models/Card";
import Billing from "@pixelpay/sdk-core/lib/models/Billing";
import Order from "@pixelpay/sdk-core/lib/models/Order";
import Item from "@pixelpay/sdk-core/lib/models/Item";
import SaleTransaction from "@pixelpay/sdk-core/lib/requests/SaleTransaction";
import Transaction from "@pixelpay/sdk-core/lib/services/Transaction";
import Helpers from '@pixelpay/sdk-core/lib/base/Helpers'

const urlCallback = process.env.REACT_APP_API_CALLBACK
const endpoint = process.env.REACT_APP_PIXELPAY_ENDPOINT
const key = process.env.REACT_APP_PIXELPAY_KEY
const hash = process.env.REACT_APP_PIXELPAY_HASH
const pixelpay_env = process.env.REACT_APP_PIXELPAY_ENV


export const directSale = async (data, correlative, email, entrepreneurship_name) => {
    const settings = new Settings()
    if (pixelpay_env === 'sandbox') {
        settings.setupSandbox()
    } else {
        settings.setupEndpoint(endpoint)
        settings.setupCredentials(
            key, Helpers.hash('MD5', hash)
        )
    }

    const card = new Card()
    card.number = data.number
    card.cvv2 = data.cvv2
    card.expire_month = data.expire_month
    card.expire_year = data.expire_year
    card.cardholder = data.cardholder

    const billing = new Billing()
    billing.address = data.address
    billing.country = data.country
    billing.state = data.state
    billing.city = data.city
    billing.phone = data.phone
    billing.zip = data.zip

    const item = new Item()
    item.code = "00001"
    item.title = entrepreneurship_name
    item.price = data.amount
    item.qty = 1

    const order = new Order()
    order.id = correlative
    order.currency = "HNL"
    order.customer_name = data.cardholder
    order.customer_email = email
    order.addItem(item)

    const sale = new SaleTransaction()
    sale.withAuthenticationRequest()
    sale.setOrder(order)
    sale.setCard(card)
    sale.setBilling(billing)
    sale.order_callback = urlCallback

    const service = new Transaction(settings)
    try {
        const response = await service.doSale(sale)
        return response
    } catch (error) {
        console.log(error);
    }
}

export const marketCenecCart = async (data, cart, idCart) => {
    const settings = new Settings()
    if (pixelpay_env === 'sandbox') {
        settings.setupSandbox()
    } else {
        settings.setupEndpoint(endpoint)
        settings.setupCredentials(
            key, Helpers.hash('MD5', hash)
        )
    }

    const card = new Card()
    card.number = data.number
    card.cvv2 = data.cvv2
    card.expire_month = data.expire_month
    card.expire_year = data.expire_year
    card.cardholder = data.cardholder

    const billing = new Billing()
    billing.address = data.address
    billing.country = data.country
    billing.state = data.state
    billing.city = data.city
    billing.phone = data.phone
    billing.zip = data.zip

    const order = new Order()
    order.id = idCart
    order.currency = "HNL"
    order.customer_name = data.cardholder
    order.customer_email = 'contenidosvisuales@chorotega.hn'

    cart.forEach(element => {
        const item = new Item()
        item.code = element.id
        item.title = element.title
        item.price = element.price
        item.qty = element.quantity
        order.addItem(element)
    });

    const sale = new SaleTransaction()
    sale.withAuthenticationRequest()
    sale.setOrder(order)
    sale.setCard(card)
    sale.setBilling(billing)

    const service = new Transaction(settings)
    try {
        const response = await service.doSale(sale)
        return response
    } catch (error) {
        console.log(error);
    }
}

export const directSaleTenant = async (data, correlative, email, pyme_name) => {
    const settings = new Settings()
    if (pixelpay_env === 'sandbox') {
        settings.setupSandbox()
    } else {
        settings.setupEndpoint(endpoint)
        settings.setupCredentials(
            key, Helpers.hash('MD5', hash)
        )
    }

    const card = new Card()
    card.number = data.number
    card.cvv2 = data.cvv2
    card.expire_month = data.expire_month
    card.expire_year = data.expire_year
    card.cardholder = data.cardholder

    const billing = new Billing()
    billing.address = data.address
    billing.country = data.country
    billing.state = data.state
    billing.city = data.city
    billing.phone = data.phone
    billing.zip = data.zip

    const item = new Item()
    item.code = "00001"
    item.title = pyme_name
    item.price = data.amount
    item.qty = 1

    const order = new Order()
    order.id = correlative
    order.currency = "HNL"
    order.customer_name = data.cardholder
    order.customer_email = email
    order.addItem(item)

    const sale = new SaleTransaction()
    sale.withAuthenticationRequest()
    sale.setOrder(order)
    sale.setCard(card)
    sale.setBilling(billing)

    const service = new Transaction(settings)
    try {
        const response = await service.doSale(sale)
        return response
    } catch (error) {
        console.log(error);
    }
}